var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container single-container",attrs:{"data-title":"blur和contrast的融合效果"}},[_c('div',{staticClass:"filter-mix"})])}]

export { render, staticRenderFns }